import React, { useEffect } from 'react'
import { Badge } from 'antd'
import { useSelector } from 'react-redux'

import { useInventory, useReports } from '../../modules'

import Routing, { MenuItem, SideMenu } from '../../components/reusable/routing'

import Invoices from './invoices'
import ChartofAccounts from './chart-of-accounts'
import Expenses from './expenses'
import Income from './income'
import Suppliers from './suppliers'
import SupplierCreditNotes from './credit-notes'
import Transactions from './transactions'
import Patients from './patients'
import Journals from './journals'
import RejectedClaims from './rejected-claims'
import ShaClaims from './sha-claims'
import ShaPreauths from './sha-preauths'
import FinanceStatements from './finance-statements'
import Dashboard from './dashboard'

let menu = [
    {
        path: '',
        title: 'Dashboard',
        component: Dashboard
    },
    {
        path: 'sales',
        title: 'Sales',
        submenu: [
            {
                path: 'patients',
                title: 'Patients',
                component: Patients
            },
            {
                path: 'invoices',
                title: 'Invoices'
            },
            {
                path: 'income',
                title: 'Income',
                component: Income
            },
            {
                path: 'credit-notes',
                title: 'Credit Notes'
            },
            {
                path: 'payments',
                title: 'Payments'
            },
            {
                path: 'sha-claims',
                title: 'SHA Claims',
                component: ShaClaims
            },
            {
                path: 'sha-preauths',
                title: 'SHA Preauths',
                component: ShaPreauths
            },
            {
                path: 'rejected-claims',
                title: 'Rejected Claims',
                component: RejectedClaims
            },
        ]
    },
    {
        path: 'purchases',
        title: 'Purchases',
        submenu: [
            {
                path: 'suppliers',
                title: 'Suppliers',
                component: Suppliers
            },
            {
                path: 'expenses',
                title: 'Expenses',
                component: Expenses
            },
            {
                path: 'recurring-expenses',
                title: 'Recurring Expenses'
            },
            {
                path: 'invoices',
                title: 'Invoices',
                component: Invoices
            },
            {
                path: 'credit-notes',
                title: 'Credit Notes',
                component: SupplierCreditNotes
            },
        ]
    },
    {
        path: 'payments',
        title: 'Payments',
        component: Transactions
    },
    {
        path: 'accountant',
        title: 'Accountant',
        submenu: [
            {
                path: 'journals',
                title: 'Manual Journals',
                component: Journals
            },
            {
                path: 'chart-of-accounts',
                title: 'Chart of Accounts',
                component: ChartofAccounts
            },
            {
                path: 'financial-statements',
                title: 'Financial Statements',
                component: FinanceStatements
            },
            {
                path: 'budgets',
                title: 'Budgets'
            }
        ]
    },
    {
        path: 'reports',
        title: 'Reports'
    },
    {
        path: 'inventory',
        title: 'Inventory'
    }
]

const storeName = "Accounts"

const Accounts = () => {
    const { user } = useSelector(state => state.application)
    const [Inventory, store, requests] = useInventory(storeName)

    const [Reports, reports] = useReports("accounts")

    useEffect(() => {
        if ((store?.permissions?.includes('*') || user?.issuperuser))
            menu[6] = {
                path: 'inventory',
                title: props => 
                    <Badge className='w-12' count={ requests }>
                        <MenuItem condition={ props?.condition }>Inventory</MenuItem>
                    </Badge>,
                component: ({ path }) => <Inventory path={ path } storeName={ storeName } />
            }

        menu[5] = {
            path: 'reports',
            title: 'Reports',
            component: ({ path }) => <Reports reports={ reports } department="accounts" />
        }
    }, [store, user, reports])

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <div className="w-1/6 overflow-y-scroll">
                <p className="text-2xl font-semibold">Accounts</p>
                <SideMenu namespace="accounts" menu={ menu } />
            </div>
            <div className="w-5/6 overflow-y-scroll">
                <Routing namespace="accounts" menu={ menu } />
            </div>
        </div>
    )
}

export default Accounts
